var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"full-block"},[_c('div',{staticClass:"d-flex"},[_c('NavigationBar')],1),_c('ArchitecturesList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }